import { PostHogProvider } from 'posthog-js/react';
import { PropsWithChildren } from 'react';
import { PendoProvider } from './pendo';
import { env, Env } from 'core/config';
import posthog from 'posthog-js';

posthog.init(env.POSTHOG_KEY, {
  api_host: env.POSTHOG_HOST,
  rageclick: true,
  capture_dead_clicks: true
});

const PostHogProviderWrapper = ({ children }: PropsWithChildren) => {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
};

const PendoProviderWrapper = ({ children }: PropsWithChildren) => {
  if (env.STAGE !== Env.prod || !env.PENDO_API_KEY) {
    return <>{children}</>;
  }
  return (
    <PendoProvider
      config={{
        apiKey: env.PENDO_API_KEY
      }}
    >
      {children}
    </PendoProvider>
  );
};

export { PostHogProviderWrapper, PendoProviderWrapper };
